import styled from "styled-components";

import { SPACING } from "../../../../utils/constants";

/**
 * The locked facts of the command being corrected — its type, its position and
 * the date it was recorded on. Rendered as context rather than as fields
 * because a correction can never move a command to another ledger: there is
 * nothing here to choose, only something to recognise.
 */
export const ContextLine = styled.p`
  margin: 0;
  color: var(--color-text-secondary);
  font-size: var(--text-sm);
  font-weight: 600;
  letter-spacing: 0.04em;
`;

export const ContextCard = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.xs}px;
  padding: ${SPACING.md}px;
  border: 1px solid var(--color-border);
  border-radius: 12px;
  background: var(--color-background-0);
`;

export const ContextHint = styled.span`
  color: var(--color-text-secondary);
  font-size: var(--text-sm);
  font-style: italic;
`;
